import * as actionTypes from "../actions/index";
import {LOCATION_CHANGE} from "connected-react-router";
import _ from "lodash";

const defaultState = {
    values: {},
    updating: false,
    fetchingEditingSettings: false,
    fetchingEditingSettingsEditableByOptions: false,
    approvalOptions: [],
    approvalSettings: [],
    updateErrorMessage: null,
    updateSuccessMessage: null
};

const changeEditingSettings = (state, action) => {
    const values = {
        ...state.values,
        [action.payload.key]: action.payload.value
    };
    if(!action.payload.value){
        delete values[action.payload.key]
    }

    return {
        ...state,
        values: values
    }
};

const updateEditingSettings = (state, action) => {
    return {
        ...state,
        updating: true,
        updateErrorMessage: null,
        updateSuccessMessage: null
    }
};

const updateEditingSettingsSuccess = (state, action) => {
    return {
        ...state,
        updating: false,
        updateSuccessMessage: "Editing setting were changed successfully.",
        approvalSettings: action.payload.body
    }
};

const updateEditingSettingsFailed = (state, action) => {
    let updateErrorMessage = "Failed to update editing settings.";
    try {
        updateErrorMessage = action.payload.response.body.message;
    } catch (e) {}
    return {
        ...state,
        updating: false,
        updateErrorMessage: updateErrorMessage
    }
};

const fetchEditingSettings = (state, action) => {
    return {
        ...state,
        fetchingEditingSettings: true
    }
};

const fetchEditingSettingsSuccess = (state, action) => {
    let values = _.keyBy(action.payload.body, e =>  e.id);

    values = _.mapValues(values, v => v.applicationAnswerApprovalOptionId);
    return {
        ...state,
        fetchingEditingSettings: false,
        approvalSettings: action.payload.body,
        values: values
    }
};

const fetchEditingSettingsFailed = (state, action) => {
    return {
        ...state,
        fetchingEditingSettings: false
    }
};

const fetchEditingSettingsEditableByOptions = (state, action) => {
    return {
        ...state,
        fetchingEditingSettingsEditableByOptions: true
    }
};

const fetchEditingSettingsEditableByOptionsSuccess = (state, action) => {
    return {
        ...state,
        fetchingEditingSettingsEditableByOptions: false,
        approvalOptions: action.payload.body
    }
};

const fetchEditingSettingsEditableByOptionsFailed = (state, action) => {
    return {
        ...state,
        fetchingEditingSettingsEditableByOptions: false
    }
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case actionTypes.CHANGE_EDITING_SETTINGS: return changeEditingSettings(state, action);
        case actionTypes.UPDATE_EDITING_SETTINGS: return updateEditingSettings(state, action);
        case actionTypes.UPDATE_EDITING_SETTINGS_SUCCESS: return updateEditingSettingsSuccess(state, action);
        case actionTypes.UPDATE_EDITING_SETTINGS_FAILED: return updateEditingSettingsFailed(state, action);
        case actionTypes.FETCH_EDITING_SETTINGS: return fetchEditingSettings(state, action);
        case actionTypes.FETCH_EDITING_SETTINGS_SUCCESS: return fetchEditingSettingsSuccess(state, action);
        case actionTypes.FETCH_EDITING_SETTINGS_FAILED: return fetchEditingSettingsFailed(state, action);
        case actionTypes.FETCH_EDITING_SETTING_EDITABLE_BY_OPTIONS: return fetchEditingSettingsEditableByOptions(state, action);
        case actionTypes.FETCH_EDITING_SETTING_EDITABLE_BY_OPTIONS_SUCCESS: return fetchEditingSettingsEditableByOptionsSuccess(state, action);
        case actionTypes.FETCH_EDITING_SETTING_EDITABLE_BY_OPTIONS_FAILED: return fetchEditingSettingsEditableByOptionsFailed(state, action);
        case LOCATION_CHANGE: return defaultState;
        case actionTypes.LOGOUT: return defaultState;
        default: return state;
    }
};